import { krdetailConstants } from '../constants/krdetails.constants';
import { isCloseKeyResultEnabled } from './okrFilterParams.util';

export const isKeyResultClosed = (metric) => (
  Number(metric?.status) === krdetailConstants.METRIC_CLOSED
);

/** Same rule the server applies: edit access on a non-mirror KR whose Objective is Open. */
export const canCloseOrReopenKeyResult = (metric, goalStatus) => !!(isCloseKeyResultEnabled()
  && (metric.canCloseKeyResult
    || (metric.canEdit
      && Number(goalStatus) === krdetailConstants.GOAL_ACTIVE
      && Number(metric.source) !== krdetailConstants.SOURCE_MIRROR_KR)));

/**
 * OKR List Page rule for KR lists: any non-mirror KR can be closed, and reopened while its
 * Objective is Open. The server still refuses users without close access.
 */
export const canCloseOrReopenFromKrList = (metric, goalStatus) => isCloseKeyResultEnabled()
  && Number(metric.source) !== krdetailConstants.SOURCE_MIRROR_KR
  && (!isKeyResultClosed(metric) || Number(goalStatus) === krdetailConstants.GOAL_ACTIVE);

/**
 * Posts Close or Reopen for one KR; resolves with every KR id the server changed (mirrors,
 * MIT and cascade children included). Failures toast the server's message and resolve with null.
 */
export const postKeyResultClosedState = ({
  goalServices, metricId, closing, t,
}) => {
  const request = closing
    ? goalServices.closeKeyResult({ metricId })
    : goalServices.reopenKeyResult({ metricId });
  const fail = (result) => {
    toastr.error(result?.message || t('Unable to update Key Result status.'));
    return null;
  };
  return request.then((response) => {
    const result = response?.data?.data;
    return result?.success ? (result.metricIds || [metricId]) : fail(result);
  }).catch((error) => fail(error?.response?.data?.data));
};

const patchKeyResultStatus = (metric, metricIds, status) => ({
  ...metric,
  ...(metricIds.has(String(metric.id)) && { status }),
  ...(metric.nested_krs && {
    nested_krs: metric.nested_krs.map((nested) => patchKeyResultStatus(nested, metricIds, status)),
  }),
});

/** Sets status on the given KRs (and nested KRs) across Team OKRs rows. */
export const setKeyResultsStatusInTeams = (teams, metricIds, status) => {
  const ids = new Set(metricIds.map(String));
  const patchGoal = (goal) => ({
    ...goal,
    goal_metrics: (goal.goal_metrics || [])
      .map((metric) => patchKeyResultStatus(metric, ids, status)),
  });
  return teams.map((team) => (team.goals ? { ...team, goals: team.goals.map(patchGoal) } : team));
};
